import Box from '../../Box/Box';
import { useTranslation } from 'react-i18next';
import InputPill from '../../Common/InputPill/InputPill';
import { useState } from 'react';

const GroupName = ({ onChangeName }) => {
  const { t } = useTranslation();
  const [name, setName] = useState('');

  const handleChange = (e) => {
    const value = e.target.value;
    setName(value);

    if (onChangeName) {
      onChangeName(value);
    }
  };

  return (
    <>
      <div className='section-title'>{t('groupName')}</div>
      <Box>
        <div className='text-secondary font-tiny'>{t('groupNameDescription')}</div>
        <div className='text-secondary font-extra-small mt-3'>
          <InputPill
            value={name}
            onChange={handleChange}
            placeholder={t('groupNamePlaceholder')}
            name='groupName'
            type='text'
            autoComplete='off'
            className='w-100'
            autoCapitalize='on'
            autoCorrect='on'
            spellCheck={true}
            inputMode='text'
          />
        </div>
      </Box>
    </>
  );
};

export default GroupName;
